export const IS_REQUIRED = 'This field is required';
export const MISSING_REQUIRED_VALUES = 'Missing required values';

export const INCOMPLETE_DATE = 'Incomplete date given';
export const INVALID_DATE = 'Invalid date given';
export const START_DATE_BEFORE_END_DATE = 'Start date must be before end date';
export const END_DATE_AFTER_START_DATE = 'End date must be after start date';
export const FIRST_OF_MONTH_DATE = 'Date must be 1st of the month';
export const LAST_OF_MONTH_DATE = 'Date must be last day of the month';
export const YEAR_MONTH_ONLY = 'This field only allows YearMonth';

export const ALPHANUMERIC_ONLY = 'This field only allows alphanumeric';
export const ALPHANUMERIC_SPACE_ONLY = 'This field only allows alphanumeric and spaces';
export const ALPHANUMERIC_UNDERSCORES_ONLY = 'This field only allows alphanumeric and underscore characters';
export const ALPHANUMERIC_CAPITALIZED_UNDERSCORES_ONLY =
    'This field only allows capitalized alphanumeric and underscore characters';
export const INVALID_REPORTING_NAME_CHARACTERS =
    'External reporting name can only contain alphanumeric characters, spaces, +, (, ), and _';

export const AT_LEAST_3_CHAR = 'This field must be at least 3 characters long';
export const AT_LEAST_5_CHAR = 'This field must be at least 5 characters long';
export const EXACTLY_4_CHAR = 'This field must be exactly 4 characters long';
export const EXACTLY_4_TO_5_CHAR = 'This field must be 4-5 characters long';
export const EXACTLY_10_CHAR = 'This field must be at exactly 10 characters long';
export const AT_MOST_8_CHAR = '8 characters long limit';
export const AT_MOST_49_CHAR = 'This field must be at most 49 characters long';
export const AT_MOST_99_CHAR = 'This field must be at most 99 characters long';
export const AT_MOST_100_CHAR = 'This field must be at most 100 characters long';
export const AT_MOST_249_CHAR = 'This field must be at most 249 characters long';
export const AT_MOST_255_CHAR = 'This field must be at most 255 characters long';
export const AT_MOST_N_CHAR = (n: number): string =>
    `This field must be at most ${n} character${n != 1 ? 's' : ''} long`;

export const MUST_GREATER_0_LESS_EQUAL_1 = 'Must be > 0 and <= 1';
export const MUST_GREATER_EQUAL_0_LESS_EQUAL_1 = 'Must be >= 0 and <= 1';
export const MUST_GREATER_EQUAL_0_LESS_EQUAL_10 = 'Must be >= 0 and <= 10';
export const VALID_NUMBER = 'This field must be a valid number';
export const MAXIMUM_ONE_DECIMAL = 'Maximum 1 decimal';
export const MUST_GREATER_EQUAL_1 = 'Must be >= 1';
export const MUST_GREATER_EQUAL_NEGATIVE_1_LESS_EQUAL_1 = 'Must be >= -1 And <= 1';
export const MUST_GREATER_EQUAL_1_LESS_EQUAL_99 = 'Must be >= 0 And <= 99';
export const MUST_BE_VALID_FRACTION_GREATER_0_LESS_EQUAL_1 = 'Must be a valid fraction > 0 and <= 1';

export const CORE_RATE_CSV_UPLOAD_MISMATCH_WITH_TEMPLATE = 'Column header(s) mismatch found comparing to the template';

export const DATE_RANGE_OVERLAP = 'Date range cannot overlap for the same granular vendor codes';

export const EXACTLY_1_ON_DEMAND_DEFINITION = 'Must be exactly 1 on-demand definition selected';
export const MUST_N_SELECTIONS = (n: number): string => `Must make ${n} selection${n != 1 ? 's' : ''}`;
export const AT_MOST_N_SELECTIONS = (n: number): string => `Must make at most ${n} selection${n != 1 ? 's' : ''}`;

export const MUST_START_WITH_ZQ = 'This field must start with "ZQ"';
